import { FeedFilter } from 'api/KnowledgeAPI';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type PostsFiltersStore = {
  filters: Record<string, FeedFilter[]>;
  userFiltersSynced: boolean;
  resetFilters: (companyId?: string) => void;
  setFilters: (companyId: string, filters: FeedFilter[], userFiltersSynced?: boolean) => void;
};

const usePostsFiltersStore = create<PostsFiltersStore>()(
  persist(
    (set) => ({
      filters: {},
      userFiltersSynced: false,
      resetFilters: (companyId) =>
        set((prevState) => ({
          filters: companyId ? { ...prevState.filters, [companyId]: [] } : {},
        })),
      setFilters: (companyId, filters, userFiltersSynced = true) =>
        set((prevState) => ({
          ...prevState,
          filters: {
            ...prevState.filters,
            [companyId]: filters,
          },
          userFiltersSynced,
        })),
    }),
    {
      name: 'posts-filters',
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({ filters: state.filters }),
    },
  ),
);

export default usePostsFiltersStore;
